import { createAction } from './helpers/createAction'
import { type RootState } from '@wellesley/store'
import { type DatedMessage } from '@wellesley/ws/types'
import { type DeviceType } from '@wellesley/ui/helpers/device'
import {
  type AccountWithUser,
  type UserFull,
  type Notification,
  type Instance,
  type PlatformSettings,
  type Group,
  type TypeId,
} from '@wellesley/openapi'
import type { NestedUserSettings } from '@wellesley/settings/helpers/nestedUserSettings'
import { type NotificationItem } from '@wellesley/notifications/types'

export const hostStoreConnect =
  createAction<Partial<RootState>>('hostStoreConnect')

export const remoteLogin = createAction('remoteLogin')
export const remoteLogout = createAction('remoteLogout')

export const wsOnMessage = createAction<DatedMessage>('wsOnMessage')

export const setRouterPath = createAction<string>('setRouterPath')
export const setDeviceType = createAction<DeviceType>('setDeviceType')
export const setDeviceWidth = createAction<number>('setDeviceWidth')

export const setUserError = createAction<unknown>('setUserError')
export const setUserIsError = createAction<boolean>('setUserIsError')
export const setUserPending = createAction<boolean>('setUserPending')
export const setUserSuccess = createAction<boolean>('setUserSuccess')
export const setUserData = createAction<AccountWithUser | null>('setUserData')
export const updateAccountData = createAction<Partial<AccountWithUser> | null>(
  'updateAccountData',
)
export const updateUser = createAction<UserFull>('updateUser')

export const addNotification = createAction<Notification>('addNotification')
export const markNotification = createAction<{
  id: string
  status: string
}>('markNotification')
export const setNotificationsError = createAction<unknown>(
  'setNotificationsError',
)
export const setNotificationsList = createAction<{
  userId: string
  list: NotificationItem[]
}>('setNotificationsList')
export const setNotificationsPending = createAction<boolean>(
  'setNotificationsPending',
)
export const setNotificationsTotalCount = createAction<number>(
  'setNotificationsTotalCount',
)
export const setNotificationsUnreadCount = createAction<number>(
  'setNotificationsUnreadCount',
)
export const acceptAllFollowRequests = createAction('acceptAllFollowRequests')
export const resetNotificationsState = createAction('resetNotificationsState')
export const undoNotification = createAction<string>('undoNotification')

export const setInstanceInfo = createAction<Instance>('setInstanceInfo')
export const setInstanceInfoPending = createAction<boolean>(
  'setInstanceInfoPending',
)
export const setInstanceInfoError = createAction<unknown>(
  'setInstanceInfoError',
)

export const setPlatformSettings = createAction<PlatformSettings>(
  'setPlatformSettings',
)

export const setProfileSettings =
  createAction<NestedUserSettings>('setProfileSettings')

export const setGroupData = createAction<[TypeId, Group]>('setGroupData')
export const setGroupLoading =
  createAction<[TypeId, boolean]>('setGroupLoading')
